

































































import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import { InjectReactive, ProvideReactive } from 'vue-property-decorator'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import { LatestNewsCollection, LatestNewsCollectionType } from '@/modules/news/models/news-collection.model'
import { AdminLatestNewsServices } from '@/modules/news/services/admin-news.service'
import NewsEdit from '@/modules/news/components/admin/NewsEdit.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    BaseButton,
    TesTr,
    TesTd,
    DateTooltipped,
    TextEllipsis,
    NewsEdit
  }
})
export default class AdminNewsRow extends mixins<TesTableRow>(TesTableRow) {

  constructor(
    private readonly adminLatestNewsServices: AdminLatestNewsServices
  ) {
    super()
  }

  @InjectReactive()
  news!: LatestNewsCollectionType

  private newsItem: LatestNewsCollection = null

  editDialog(newsItem) {
    //(shallow copy)copy newsItem Object
    this.newsItem = { ...newsItem }
    this.$q.dialog({
      component: NewsEdit,
      newsItem: this.newsItem
    })
  }

  destroy(id: number) {
    this.adminLatestNewsServices.destroy(id)
  }
}
